import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { CONFIRM_JOB_ACTION, clearSelectedJob, confirmJob } from '~/actions';
import { ICounterOfferEntity } from '~/domain/Jobs';
import { useAppSelector, useIsSuccess, useLoading, useToggle } from '~/hooks';

interface IUseConfirmInterview {
  professionalId: string;
  officeId?: string;
}

export const useConfirmInterview = ({ professionalId, officeId }: IUseConfirmInterview) => {
  const dispatch = useDispatch();

  const selectedInterviewIdRef = useRef<string | null>(null);
  const counterOfferRef = useRef<ICounterOfferEntity | null>(null);
  const [isOpen, controls] = useToggle();

  const professional = useAppSelector((state) => state.user.professionalProfile);

  const { isLoading } = useLoading([CONFIRM_JOB_ACTION]);
  const { clearSuccess } = useIsSuccess([CONFIRM_JOB_ACTION]);

  const handleConfirmInterview = (interviewId: string, counterOffer: ICounterOfferEntity) => {
    selectedInterviewIdRef.current = interviewId;
    counterOfferRef.current = counterOffer;
    controls.setOn();
  };

  const handleConfirmCandidateInterview = (notes?: string) => {
    if (!selectedInterviewIdRef.current || !counterOfferRef.current || !professional) return;

    dispatch(
      confirmJob({
        jobId: selectedInterviewIdRef.current,
        data: { notes },
        counterOfferId: counterOfferRef.current.id,
        candidate: {
          id: professional.id,
          full_name: professional.full_name,
          profile_image: professional.profile_image,
        },
        officeId,
      }),
    );
  };

  const handleCloseConfirmInterview = () => {
    selectedInterviewIdRef.current = null;
    counterOfferRef.current = null;
    controls.setOff();
    clearSuccess();
    dispatch(clearSelectedJob());
  };

  return {
    isConfirming: isLoading,
    isOpen,
    selectedInterviewId: selectedInterviewIdRef.current,
    handleCloseConfirmInterview,
    handleConfirmInterview,
    handleConfirmCandidateInterview,
  };
};
